import { useEffect } from 'react'

import useApiGet from 'Pods/Shared/Hooks/useApiGet'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { VARIATION_TYPES } from 'Pods/ThreeDStudio/constants'
import { restoreActiveConversion } from 'Pods/ThreeDStudio/Store/actions/export'
import { addActiveRun } from 'Pods/ThreeDStudio/Store/actions/generation'
import { GENERATION_TRIGGER_KEY } from 'Pods/ThreeDStudio/Store/constants'

const toStartedAt = (createdAt) => {
  const parsed = createdAt ? new Date(createdAt).getTime() : NaN
  return Number.isNaN(parsed) ? Date.now() : parsed
}

export default function usePendingGeneratorRun() {
  const { getData } = useApiGet()
  const { isCurrentUser: isLoggedIn } = usePageConfig() || {}

  useEffect(() => {
    if (isLoggedIn !== true) {
      return
    }

    getData({
      path: '/api/internal/generator/runs/pending',
      onSuccess: (response) => {
        const sessions = response.data?.data || []

        // Every in-flight run is restored (paid tiers can run several concurrently);
        // each gets its own activeRuns entry and channel subscription.
        sessions.forEach(({ session, runs }) => {
          (runs || []).forEach(({
            id: runId,
            created_at: createdAt,
            providerModelId,
            createdNewSession,
          }) => {
            if (runId == null) {
              return
            }

            // A run that did not create a new session and whose provider model is an
            // enhancement is an in-flight enhancement: restore the "Processing..." card
            // for its session and resume the in-progress label on the originating tab's
            // button. An initial generation (new session) gets its own "Generating..."
            // card pinned to the main generate button instead.
            const variationType = VARIATION_TYPES[providerModelId]
            const isEnhancement = createdNewSession === false && !!variationType?.isEnhancement
            addActiveRun({
              clientId: `pending-run-${runId}`,
              runId,
              sessionId: session,
              startedAt: toStartedAt(createdAt),
              isEnhancement,
              enhancingSessionId: isEnhancement ? session : undefined,
              triggeredBy: isEnhancement ? (variationType.tab ?? null) : GENERATION_TRIGGER_KEY,
              // A restored run has no `settings` (that snapshot only exists in the tab that
              // started it), so keep the provider model id: it is the other half of the
              // payload setOpenedModel needs when the user opens this run's card.
              providerModelId,
            })
          })
        })

        const activeConversion = response.data?.active_conversion
        if (activeConversion) {
          restoreActiveConversion(activeConversion)
        }
      },
    })
  }, [getData, isLoggedIn])
}
